// Typelizer digest ab43f24cb0c93d0bff1e3f6326f9b862
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/bank_accounts/:bank_account_id/raw_bank_transactions */
  index: (
    params: { bankAccountId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/bank_accounts/:bank_account_id/raw_bank_transactions', params, options),
    method: 'get',
  }),
}
